"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var arrayUnique = function arrayUnique(array) {
  var a = array.concat();

  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }

  return a;
};

var isDataEquiv = function isDataEquiv(val1, val2) {
  if (val1 instanceof Date && val2 instanceof Date) {
    return val1.getTime() === val2.getTime();
  }

  return val1 === val2;
};

var useAmChartData = function useAmChartData(amChart, data, onChange) {
  var storedData = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    if (!amChart) {
      return;
    }

    var newDataItems = [];
    var removedDataItems = [];
    var updatedDataItem = [];
    data.map(function (dataItem, index) {
      var match;

      if (dataItem.id) {
        match = storedData.current.find(function (storedDataItem) {
          return storedDataItem.id === dataItem.id;
        });
      } else {
        match = storedData.current[index];
      }

      if (!match) newDataItems.push(dataItem);
    });
    storedData.current.map(function (storedDataItem, index) {
      var match;

      if (storedDataItem.id) {
        match = data.find(function (dataItem) {
          return dataItem.id === storedDataItem.id;
        });
      } else {
        match = data[index];
      }

      if (!match) removedDataItems.push(storedDataItem);
    });
    storedData.current.map(function (storedDataItem, index) {
      var match;

      if (storedDataItem.id) {
        match = data.find(function (dataItem) {
          return dataItem.id === storedDataItem.id;
        });
      } else {
        match = data[index];
      }

      if (match) {
        var keys = arrayUnique(Object.keys(storedDataItem).concat(Object.keys(match)));
        keys.forEach(function (key) {
          if (!isDataEquiv(storedDataItem[key], match[key])) {
            updatedDataItem.push({
              key: key,
              old: storedDataItem,
              "new": match
            });
          }
        });
      }
    });
    storedData.current = (0, _lodash["default"])(data);
    onChange({
      newData: newDataItems,
      removedData: removedDataItems,
      updatedData: updatedDataItem
    });
  }, [amChart, data, onChange]);
  var invalidateData = (0, _react.useCallback)(function () {
    amChart.data = storedData.current;
  }, [amChart]);
  return {
    invalidateData: invalidateData,
    storedData: storedData.current
  };
};

var _default = useAmChartData;
exports["default"] = _default;